import {createSelector} from 'reselect'
import {selectUser} from './entity'

export const selectUserFirstName = createSelector(selectUser, user => user?.firstName)

export const selectUserLastName = createSelector(selectUser, user => user?.lastName)
